import { ListItemText } from "@mui/material";

export function NCRSideBarListItemText({ props = {}, primary, open }) {
  return (
    <ListItemText
      primary={primary}
      sx={{
        opacity: open ? 1 : 0,
        '& .MuiTypography-root': {
          fontFamily: 'Lato, sans-serif',
          fontWeight : 400,
          // fontSize : '14px',
          ...(props.sx || {}),
        },
      }}
    />
  );
}